import { useEffect, useState } from 'react';
import { PageLocationSummary } from 'types/markerTypes/location.page.js';

export const FavouriteCurrentLocationHook = ({ location }: { location?: PageLocationSummary }) => {
  const [key, setKey] = useState(location?.key);
  const [type, setType] = useState(location?.type);
  const [favouriteKey, setFavouriteKey] = useState(location?.favouriteKey);
  const [favouriteType, setFavouriteType] = useState(location?.favouriteType);

  useEffect(() => {
    if (key !== location?.key) {
      setKey(location?.key);
    }
    if (type !== location?.type) {
      setType(location?.type);
    }
    if (favouriteKey !== location?.favouriteKey) {
      setFavouriteKey(location?.favouriteKey);
    }
    if (favouriteType !== location?.favouriteType) {
      setFavouriteType(location?.favouriteType);
    }
  }, [location, key, type, favouriteKey, favouriteType]);

  return { favouriteKey, favouriteType, key, type };
};
